import * as React from 'react';
import { Theme, ThemeT } from '~/lib/types';
import { Button } from '../ui/button';
import { Moon, Sun } from './icons';

export default function ThemeSelector() {
  const [theme, setTheme] = React.useState<ThemeT>(Theme.LIGHT);

  React.useEffect(() => {
    const theme = localStorage.getItem('theme');
    if (isDark(theme)) {
      document.documentElement.classList.add('dark');
      setTheme(Theme.DARK);
    }
  }, []);

  const toggleTheme = () => {
    if (isDark(theme)) {
      document.documentElement.classList.remove('dark');
      localStorage.setItem('theme', Theme.LIGHT);
    } else {
      document.documentElement.classList.add('dark');
      localStorage.setItem('theme', Theme.DARK);
    }
    setTheme(isDark(theme) ? Theme.LIGHT : Theme.DARK);
  };

  return (
    <Button variant="outline" size="icon" onClick={toggleTheme} className="">
      {isDark(theme) ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
    </Button>
  );
}

const isDark = (theme: ThemeT | string | null) => theme === Theme.DARK;
